import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Building2, ChevronRight } from 'lucide-react';
import { Card, CardContent } from '../ui/card';
import { Button } from '../ui/button';
import { formatCurrency } from './constants';

const IGSSStatsCard = ({ igssStats }) => {
  const navigate = useNavigate();

  const handleClick = () => {
    // Navigate to patients page with IGSS institution filter
    navigate('/pacientes?institucion=IGSS');
  };

  return (
    <Card 
      className="bg-white border border-slate-200 border-l-4 border-l-teal-500 shadow-sm hover:shadow-md transition-shadow duration-300 cursor-pointer"
      onClick={handleClick}
      data-testid="igss-stats-card"
    >
      <CardContent className="p-6">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-4">
            <div className="w-12 h-12 rounded-xl bg-teal-50 flex items-center justify-center">
              <Building2 className="w-6 h-6 text-teal-600" strokeWidth={1.5} />
            </div>
            <div>
              <p className="text-sm text-slate-500 font-medium mb-1">Estudios IGSS del Mes</p>
              <div className="flex items-baseline gap-3">
                <p className="font-heading text-2xl font-bold text-teal-600">
                  {igssStats.count}
                </p>
                <span className="text-sm text-slate-400">estudios</span>
                <span className="text-lg font-semibold text-slate-700">
                  {formatCurrency(igssStats.total)}
                </span>
              </div>
            </div>
          </div>
          <Button 
            variant="ghost" 
            size="sm" 
            className="text-teal-600 hover:text-teal-700 hover:bg-teal-50"
            onClick={(e) => { e.stopPropagation(); handleClick(); }}
          >
            Ver pacientes IGSS
            <ChevronRight className="w-4 h-4 ml-1" />
          </Button>
        </div>
      </CardContent>
    </Card>
  );
};

export default IGSSStatsCard;
